import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { cloneDeep, isEqual } from 'lodash-es';

import CheckBoxFilter from '../../../_shared/components/CheckBoxFilter';
import FilterDisplayBox from '../../../_shared/components/FilterDisplayBox';
import { HeaderType, FilterType } from '../../../_shared/constants/filters';
import PopoverWrapper from '../../../_shared/components/Popover';
import FilterService from '../../../services/FilterService';

const propTypes = {
  provinces: PropTypes.objectOf(PropTypes.object).isRequired,
  updateFilter: PropTypes.func.isRequired
};

const ProvinceFilter = ({ provinces, updateFilter }) => {
  const intl = useIntl();

  const [currentProvinces, setCurrentProvinces] = useState(provinces);

  useEffect(() => {
    setCurrentProvinces(cloneDeep(provinces));
  }, [provinces]);

  const updateProvinces = useCallback(
    list => {
      // Check if there has been an update to Provinces
      if (isEqual(list, provinces)) {
        return;
      }
      setCurrentProvinces(list);
      updateFilter(list, FilterType.Location);
    },
    [provinces, updateFilter]
  );

  const popoverChildFn = useCallback(() => {
    return setIsOpen => {
      const title = FilterService.formatItemsSelected(currentProvinces, {
        all: 'list.filters.provinces.all',
        some: 'list.filters.provinces.some'
      });

      return (
        <FilterDisplayBox
          openDropDown={() => setIsOpen(isOpen => !isOpen)}
          title={title}
          popOverOpen={setIsOpen}
          testId="province-filter-dropdown"
        />
      );
    };
  }, [currentProvinces]);

  const popoverLocation = useCallback(
    () => openPopOver => (
      <CheckBoxFilter
        filterList={currentProvinces}
        headerType={HeaderType.Base}
        headerTitle={intl.formatMessage(
          { id: 'list.filters.province' },
          { provinceCount: 1 }
        )}
        openPopOver={openPopOver}
        handleFilterApply={updateProvinces}
        testId="province-filter"
      />
    ),
    [currentProvinces, intl, updateProvinces]
  );

  return (
    <PopoverWrapper
      align="start"
      position={['bottom']}
      renderContent={popoverLocation()}
      renderChild={popoverChildFn()}
      data-testid="province-filter"
    />
  );
};

ProvinceFilter.propTypes = propTypes;

export default ProvinceFilter;
